<div class="flex flex-col">
    <button
        type="button"
        (click)="navigate()"
        class="text-primary-800 select-text"
    >
        {{ getDisplayAppId() }}
    </button>
    @if (params.data.pscaId && !this.params.data.isForm160) {
        <span>{{ params.data.pscaId }}</span>
    }
</div>
